import { createSlice } from "@reduxjs/toolkit";
const initialUIState = {
  smallModal: {
    isModalOpen: false,
    title: null,
    text: null,
    body: null,
    cancelText: null,
    confirmText: null,
  },
  searchTool: {
    filters: {},
    options: {},
  },
  rentSlider: {
    show: false,
    minValue: null,
    maxValue: null,
  },
  buySlider: {
    show: false,
    minValue: null,
    maxValue: null,
  },
  selectedRentBuy: null,
  availablePlaces: null,
  availablePropertyType: null,
  selectedPlace: null,
  selectedPropertyType: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState: initialUIState,
  reducers: {
    setIsModalOpen(state, action) {
      state.smallModal.isModalOpen = action.payload;
    },
    setModalTitle(state, action) {
      state.smallModal.title = action.payload;
    },
    setModalText(state, action) {
      state.smallModal.text = action.payload;
    },
    setModalBody(state, action) {
      state.smallModal.body = action.payload;
    },
    setModalConfirmText(state, action) {
      state.smallModal.confirmText = action.payload;
    },
    setModalCancelText(state, action) {
      state.smallModal.cancelText = action.payload;
    },
    setShowRentSlider(state, action) {
      state.rentSlider.show = action.payload;
    },
    setMinRentSlider(state, action) {
      state.rentSlider.minValue = action.payload;
    },
    setMaxRentSlider(state, action) {
      state.rentSlider.maxValue = action.payload;
    },
    setShowBuySlider(state, action) {
      state.buySlider.show = action.payload;
    },
    setMinBuySlider(state, action) {
      state.buySlider.minValue = action.payload;
    },
    setMaxBuySlider(state, action) {
      state.buySlider.maxValue = action.payload;
    },
    setSelectedRentBuy(state, action) {
      state.selectedRentBuy = action.payload;
    },
    setAvailablePlaces(state, action) {
      state.availablePlaces = action.payload;
    },
    setSelectedPlace(state, action) {
      state.setSelectedPlace = action.payload;
    },
    setAvailablePropertyTypes(state, action) {
      state.availablePropertyType = action.payload;
    },
    setSelectedPropertyType(state, action) {
      state.selectedPropertyType = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
